import { Zap } from "lucide-react";
import { t } from "@/i18n/sk";

export function AnnouncementBar() {
  return (
    <div
      data-testid="announcement-bar"
      className="flex items-center justify-center gap-2 border-b border-violet-glow/20 bg-vault-black/90 px-4 py-2 text-center font-mono text-[0.72rem] tracking-wide text-cyan-200 backdrop-blur"
    >
      <Zap className="h-3.5 w-3.5 text-violet-300" />
      <span>{t.announcement}</span>
    </div>
  );
}

export default AnnouncementBar;
